const rankingItems = [
  {
    rank: 1,
    title: '长安诡事录',
    subtitle: '古装悬疑热播剧',
    tag: '国产剧',
    heat: '986万',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20mystery%20drama%20scene%20with%20dramatic%20lighting%2C%20traditional%20costume%20characters%20in%20shadow%2C%20cinematic%20historical%20atmosphere%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20film%20noir%20Chinese%20aesthetic&width=400&height=240&seq=ranking-01-drama&orientation=landscape',
    alt: '91影视看片下载 - 长安诡事录',
  },
  {
    rank: 2,
    title: '星际救援',
    subtitle: '好莱坞科幻巨制',
    tag: '科幻',
    heat: '875万',
    img: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20rescue%20scene%20with%20astronauts%20and%20starship%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20blockbuster%20atmosphere%2C%20deep%20blue%20and%20gold%20contrast%2C%20movie%20poster%20style%20composition&width=400&height=240&seq=ranking-02-scifi&orientation=landscape',
    alt: '91影视看片下载 - 星际救援',
  },
  {
    rank: 3,
    title: '爱情公寓6',
    subtitle: '都市喜剧重磅回归',
    tag: '喜剧',
    heat: '792万',
    img: 'https://readdy.ai/api/search-image?query=Bright%20modern%20apartment%20comedy%20scene%20with%20young%20friends%20gathering%2C%20warm%20living%20room%20lighting%2C%20cheerful%20sitcom%20atmosphere%2C%20colorful%20and%20vibrant%20cinematic%20style%2C%20Chinese%20urban%20comedy%20aesthetic&width=400&height=240&seq=ranking-03-comedy&orientation=landscape',
    alt: '91影视看片下载 - 爱情公寓6',
  },
  {
    rank: 4,
    title: '迷雾追踪者',
    subtitle: '国产悬疑推理力作',
    tag: '悬疑',
    heat: '683万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20scene%20with%20rainy%20city%20street%20at%20night%2C%20detective%20silhouette%20in%20fog%2C%20noir%20cinematic%20lighting%2C%20suspenseful%20atmosphere%2C%20film%20noir%20urban%20aesthetic%2C%20deep%20shadows%20and%20moody%20tones&width=400&height=240&seq=ranking-04-mystery&orientation=landscape',
    alt: '91影视看片下载 - 迷雾追踪者',
  },
  {
    rank: 5,
    title: '功夫世家',
    subtitle: '动作喜剧贺岁大片',
    tag: '动作',
    heat: '597万',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20martial%20arts%20action%20scene%20with%20Chinese%20kung%20fu%20masters%2C%20dramatic%20fight%20choreography%2C%20warm%20golden%20hour%20lighting%2C%20epic%20cinematic%20composition%2C%20traditional%20Chinese%20architecture%20background%2C%20action%20movie%20aesthetic&width=400&height=240&seq=ranking-05-action&orientation=landscape',
    alt: '91影视看片下载 - 功夫世家',
  },
  {
    rank: 6,
    title: '深海密码',
    subtitle: '冒险纪录剧集',
    tag: '纪录',
    heat: '514万',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20ocean%20exploration%20scene%20with%20bioluminescent%20creatures%2C%20underwater%20cinematic%20lighting%2C%20documentary%20style%20composition%2C%20deep%20blue%20and%20teal%20tones%20with%20golden%20accents%2C%20nature%20adventure%20aesthetic&width=400&height=240&seq=ranking-06-ocean&orientation=landscape',
    alt: '91影视看片下载 - 深海密码',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            热门榜单
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            影视热度排行榜
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            基于全网播放数据的实时热度榜单，发现大家都在看的热门影视
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#"
              className="group flex gap-4 p-4 bg-background-50 rounded-xl transition-all duration-300 cursor-pointer"
            >
              <div className="flex-shrink-0 w-20 md:w-24">
                <div className="relative rounded-lg overflow-hidden aspect-[3/4]">
                  <img
                    src={item.img}
                    alt={item.alt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                    onError={(e) => {
                      const el = e.currentTarget;
                      el.style.display = 'none';
                      (el.parentElement as HTMLElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute top-0 left-0 w-7 h-7 bg-primary-500 flex items-center justify-center">
                    <span className="text-background-50 text-xs font-bold">{item.rank}</span>
                  </div>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-foreground-400 text-xs whitespace-nowrap">
                    <i className="ri-fire-line w-3 h-3 inline-flex items-center justify-center mr-0.5"></i>
                    {item.heat}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs mt-1 truncate">{item.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}